export default __webpack_public_path__ + "static/thum-video-img04-cacac480b7fb3617a31b70a238f5e750.jpg";